import React from 'react';

interface SubmitButtonProps {
	classNames?: string;
	children?: any;
	clickHandler?: () => any;
}

export const SubmitButton = ({
	classNames = 'ring-0',
	children,
	clickHandler,
}: SubmitButtonProps) => (
	<div className='relative inline-block'>
		<button className={classNames} onClick={clickHandler}>
			{children}
		</button>
	</div>
);

export default SubmitButton;
